import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverController } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { add, location, share, close, navigate, trash, create, eye } from 'ionicons/icons';

export interface ContextMenuOption {
  id: string;
  label: string;
  icon?: string;
  iconSrc?: string; // For custom SVG icons
  type?: 'default' | 'destructive' | 'primary';
  data?: any;
}

@Component({
  selector: 'app-context-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss'
})
export class ContextMenuComponent {
  @Input() title: string = 'Opciones';
  @Input() options: ContextMenuOption[] = [];
  @Input() data?: any; // Additional data to pass back with selection
  
  private popoverCtrl = inject(PopoverController);
  
  constructor() {
    addIcons({ add, location, share, close, navigate, trash, create, eye });
  }
  
  onOptionSelect(option: ContextMenuOption) {
    // Dismiss popover with selected option data
    this.popoverCtrl.dismiss({
      action: option.id,
      option: option,
      data: this.data
    }, 'select');
  }
  
  onCancel() {
    this.popoverCtrl.dismiss(null, 'cancel');
  }
  
  getOptionTypeClass(option: ContextMenuOption): string {
    switch (option.type) {
      case 'destructive':
        return 'action-btn-destructive';
      case 'primary':
        return 'action-btn-primary';
      default:
        return '';
    }
  }
}
